import EcoNavProduct, { EcoNavProductProps } from 'eco-design/sections/eco-nav-product';
import { useRouter } from 'next/router';
import { productPageUrl } from '../../config/pageConfig';
import styles from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import gtm from '@/utils/gtm';
export default function ProductNav({ activeTab, tabCallback }: { activeTab: string; tabCallback?: any }) {
    const { locale = 'us', pathname } = useRouter();
    const { t } = useLang('theProduct.overview');
    const thePageUrl = `/${locale}/${productPageUrl}`;
    const isInProductPage = pathname.endsWith(productPageUrl);

    const dataA: EcoNavProductProps = {
        theme: 'black',
        productItems: [
            {
                value: 'name1',
                label: t('overview_name'),
            },
        ],
        tabItems: [
            {
                value: 'Product',
                label: t('overview_main'),
                href: isInProductPage ? undefined : thePageUrl,
            },
            {
                value: 'Specs',
                label: t('overview_specs'),
                href: `${thePageUrl}/specs`,
            },
        ],
        buyItems: [],
    };
    const tabChange = (item: any, index: number) => {
        if (tabCallback) {
            gtm.push({
                event: 'uaEvent',
                event_name: 'product_navigation',
                navigation_name: item.value,
                product_name: 'EcoFlow STREAM Series Balcony Power Plant',
            });
            tabCallback(item.value);
        }
    };

    return (
        <div className={styles.comp}>
            <EcoNavProduct {...dataA} defaultTabActiveKey={activeTab} onTabChange={tabChange} />
        </div>
    );
}
